module.exports = __webpack_public_path__ + "img/copy.b037af16.png";